import { app } from "router/routes"
import { useMemo } from "react"


const useMenuBarItems = () => {

    const menuBarItems = useMemo(
        () => [
            {
                label: <>
                    <div>{"הכרות כללית"}</div>
                    <div>{"עם המערכת"}</div>
                </>,
                to: app.tutorial1
            },
            {
                 label: <>
                    <div>{"הוספת תלמידים"}</div>
                    <div>{"והקצאת מבדקים"}</div>
                </>,
                to: app.tutorial2
            },
            {
                label: "ביצוע מבדקים",
                to: app.tutorial3
            },
            {
                label: "דוחות",
                to: app.tutorial4
            }
        ], []
    )

    return menuBarItems
}


export default useMenuBarItems